import React from 'react';
import PropTypes from 'prop-types';
import './SingleTradeOrder.scss';
import Table from '../../../../../Common/Table/Table';
import { singleTradeOrderCols } from './columns';
import { useAssetsSignatures } from '../../../../../../hooks/useAssetsSignatures';

export const SingleTradeOrder = ({ tradeOrder, ...rest }) => {
  const [, , , setModifiedAssetSignatures, loading] = useAssetsSignatures('TradeOrder');
  const { order_type: orderType } = tradeOrder || {};
  const signInfo = {
    signMethod: setModifiedAssetSignatures,
    loading,
  };
  return (
    <div className="sign-trade-wrapper single">
      <Table dataSourse={[tradeOrder]} hiddenCols={[]} cols={singleTradeOrderCols(orderType, signInfo)} {...rest} />
    </div>
  );
};
SingleTradeOrder.propTypes = {
  tradeOrder: PropTypes.object.isRequired,
};
